export const surgicalMeshBoxes = [
  "6x11 cms",
  "7.6x15 cms",
  "10x15 cms",
  "12x15 cms",
  "12x18 cms",
  "15x15 cms",
  "15x20 cms",
  "20x30 cms",
  "30x30 cms"
];
